
export const GET_CURRENT_ID = state => state.currentId;

export const GET_LOAD = state => state.loadMap;


// WEBPACK FOOTER //
// ./src/store/getters.js